module.exports = __webpack_public_path__ + "static/avatar_jz-64eea220021ea405a2d8a4ef157c0327.png";